import { render, staticRenderFns } from "./ChoiceHelpTab.vue?vue&type=template&id=2772022f&"
import script from "./ChoiceHelpTab.vue?vue&type=script&lang=js&"
export * from "./ChoiceHelpTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports